import SchedulePositionTableRow from "./SchedulePositionTableRow";
import { ScheduleDocument, SchedulePosition } from "../../interfaces/ISchedules";
import {
  getScheduleTableHeaderCellStyles,
  getScheduleTableHeaderStyles,
} from "../../utils/scheduleTableStyles";
import { Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";

interface ScheduleDayTableProps {
  schedule: ScheduleDocument;
  onPositionClick: (position: SchedulePosition) => void;
}

/**
 * Tabela pozycji jednego dnia harmonogramu (read-only, port logiki z host-panel).
 */
export default function ScheduleDayTable({ schedule, onPositionClick }: ScheduleDayTableProps) {
  const theme = useTheme();
  const tableHeaderStyles = getScheduleTableHeaderStyles(theme);
  const tableHeaderCellStyles = getScheduleTableHeaderCellStyles(theme);

  if (!schedule.positions || schedule.positions.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 0 }}>
        Ten harmonogram nie zawiera jeszcze żadnych pozycji.
      </Alert>
    );
  }

  return (
    <TableContainer sx={{ mt: { xs: 1, sm: 0 }, overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={tableHeaderStyles}>
            <TableCell sx={tableHeaderCellStyles} align="center">
              Czas
            </TableCell>
            <TableCell sx={tableHeaderCellStyles}>Pozycja</TableCell>
            <TableCell sx={tableHeaderCellStyles} align="right">
              Prezentacje
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schedule.positions.map((position, positionIndex) => (
            <SchedulePositionTableRow
              key={position.id || positionIndex}
              position={position}
              positionIndex={positionIndex}
              scheduleId={schedule.id}
              onPositionClick={onPositionClick}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
